module.exports = __webpack_public_path__ + "img/UTDEAD-7.9389b816.jpg";